export default __webpack_public_path__ + "static/media/ROM SYLLABUS_2026-27 CLASS 9.86307dc9.pdf";